/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import Checkbox from '@tds/core-checkbox';
import { getStepThreeSchema } from './schema';
import { useTranslationsContext } from '../context/TranslationsContext';

const StepThree = ({
  onSubmit,
  stepData: { productOfInterest, product, additionalComments },
  isSubmitting
}) => {
  const translations = useTranslationsContext();
  const {
    REFERRALS: {
      stepThree: { labels, errorLabels },
      modalData: { submit }
    }
  } = translations;
  const [wireline, wireless] = labels.productOfInterestOptions;
  const options = labels.productOptionsWireline.concat(
    labels.productOptionsWireless
  );
  const uniqueOptions = [...new Set(options)];
  return (
    <div className='layout-container'>
    <Formik
      validationSchema={getStepThreeSchema(errorLabels)}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
      initialValues={{
        productOfInterest: productOfInterest || '',
        product: product || '',
        additionalComments: additionalComments || ''
      }}
    >
      {({ errors, touched, values, setFieldValue, handleChange }) => (
        <Form>
          <div className="main-content-form-headers" style={{ marginTop: 20 }}>
            <span className="select-placeholder">
              {labels.productOfInterest}*
            </span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${
              errors.productOfInterest && touched.productOfInterest
                ? 'error'
                : ''
            }`}
          >
            <label style={{ display: 'flex' }}>
              <Field
                name="productOfInterest"
                as={Checkbox}
                type="checkbox"
                value={wireline}
                className="select-style"
              />{' '}
              {wireline}
            </label>
            <label style={{ display: 'flex' }}>
              <Field
                name="productOfInterest"
                as={Checkbox}
                type="checkbox"
                value={wireless}
                className="select-style"
              />{' '}
              {wireless}
            </label>
            <label>
              <div>
                <span className="frg-body-font-16px warning-error-message">
                  {errors.productOfInterest}
                </span>
              </div>
            </label>
          </div>

          {values.productOfInterest && values.productOfInterest.length > 0 && (
            <div className="main-content-form-headers">
              <span className="select-placeholder">{labels.product}*</span>
            </div>
          )}
          {values.productOfInterest[0] === wireline &&
            values.productOfInterest.length === 1 &&
            labels.productOptionsWireline.map(option => (
              <label
                style={{ display: 'flex' }}
                key={`checkbox-item-${option}`}
              >
                <Field
                  type="checkbox"
                  as={Checkbox}
                  name="product"
                  value={option}
                />
                {option}
              </label>
            ))}
          {values.productOfInterest[0] === wireless &&
            values.productOfInterest.length === 1 &&
            labels.productOptionsWireless.map(option => (
              <label
                style={{ display: 'flex' }}
                key={`checkbox-item-${option}`}
              >
                <Field
                  type="checkbox"
                  as={Checkbox}
                  name="product"
                  value={option}
                />
                {option}
              </label>
            ))}
          {values.productOfInterest.includes(wireline) &&
            values.productOfInterest.includes(wireless) &&
            uniqueOptions.map(option => (
              <label
                style={{ display: 'flex' }}
                key={`checkbox-item-${option}`}
              >
                <Field
                  type="checkbox"
                  as={Checkbox}
                  name="product"
                  value={option}
                />
                {option}
              </label>
            ))}
          {values.productOfInterest && values.productOfInterest.length > 0 && (
            <label>
              <div>
                <span className="frg-body-font-16px warning-error-message">
                  {errors.product}
                </span>
              </div>
            </label>
          )}
          <div className="main-content-form-headers">
            <span className="select-placeholder">
              {labels.additionalComments}
            </span>
          </div>
          <div
            style={{ position: 'relative' }}
            className={`input-container ${
              errors.additionalComments && touched.additionalComments
                ? 'error'
                : ''
            }`}
          >
            <Field
              name="additionalComments"
              type="text"
              className="select-style"
              as="textarea"
              placeholder={labels.additionalComments}
            />
          </div>
          <button className="frg-button color-green" type="submit">
            {isSubmitting ? 'Submiting...' : submit}
          </button>
        </Form>
      )}
    </Formik>
    </div>
  );
};

/* eslint-enable */
export default StepThree;
